import { useTranslation } from 'react-i18next';

import { TripArrayFieldNotesInput } from './TripArrayFieldNotesInput';

export function DropoffNotesField({ index }: { index: number }) {
  const { t } = useTranslation('common');
  return (
    <TripArrayFieldNotesInput
      index={index}
      tripField="dropoffNotes"
      label={t('reservation.notes')}
    />
  );
}
